import React from 'react';
import { Controller } from 'react-hook-form';
import { MyMDatePicker } from '../ui-elements/MyMDatePicker';
import dayjs from 'dayjs';

/**
 * 入力チェック用DatePicker Component
 */
const ValidatableDatePicker = ({ control, name, value, rules, formState, width, color, onChange }) => {
  return (
    // 2026.6.9 ブラウザ言語による日付選択時のエラー対応 Modify Start
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, ...field } }) =>
        <MyMDatePicker
          {...field}
          value={value ? dayjs(value) : null}
          color={color}
          onChange={((e) => {
            field.onChange(e);
            onChange && onChange(e);
          })}
          formState={formState}
          name={name}
          sx={{ width: width }}
        />
      }
      rules={rules}
    />
    // 2026.6.9 ブラウザ言語による日付選択時のエラー対応 Modify End
  );
};
export default ValidatableDatePicker;